var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7849_153678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7849_153678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "door_open",
    d: "M11 12.8846C11.2513 12.8846 11.4616 12.7984 11.6308 12.6259C11.8 12.4535 11.8846 12.2448 11.8846 12C11.8846 11.7487 11.8 11.5384 11.6308 11.3692C11.4616 11.2 11.2513 11.1154 11 11.1154C10.7551 11.1154 10.5465 11.2 10.3741 11.3692C10.2016 11.5384 10.1154 11.7487 10.1154 12C10.1154 12.2448 10.2016 12.4535 10.3741 12.6259C10.5465 12.7984 10.7551 12.8846 11 12.8846ZM7.00001 20.5V19L13.5 18.1538V6.66343C13.5 6.34931 13.401 6.07303 13.2029 5.83458C13.0049 5.59611 12.7571 5.46021 12.4596 5.42688L7.30773 4.74995V3.25L12.6731 3.95768C13.3487 4.05896 13.9055 4.36216 14.3433 4.86728C14.7811 5.37241 15 5.96279 15 6.63843V19.4192L7.00001 20.5ZM3.73083 20.5V19H5.50004V5.05768C5.50004 4.54229 5.67664 4.11217 6.02986 3.7673C6.38306 3.42243 6.80902 3.25 7.30773 3.25H16.6923C17.2077 3.25 17.6378 3.42243 17.9827 3.7673C18.3275 4.11217 18.5 4.54229 18.5 5.05768V19H20.2692V20.5H3.73083ZM7.00001 19H17V5.05768C17 4.96793 16.9712 4.8942 16.9135 4.8365C16.8558 4.7788 16.782 4.74995 16.6923 4.74995H7.30773C7.21798 4.74995 7.14426 4.7788 7.08656 4.8365C7.02886 4.8942 7.00001 4.96793 7.00001 5.05768V19Z",
    fill: "#A5ACB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door_open.efd0059e1bd894eeb350d8fd72424e36.svg";
export { ForwardRef as ReactComponent };